export { Pypestream as default } from '@fhs-legacy/frontend/src/pages/pypestream/pypestream';
